import Vue from 'vue';
import VueSpinners from 'vue-spinners';

Vue.use(VueSpinners);
